import { FC, useEffect, useMemo, useState } from "react";
import { IOrder } from "../../model/IOrder";
import { IRole, TRole } from "../../model/IRole";
import SelectSearch, { TSelectHandler } from "../common/selectSearch/SelectSearch";
import Input, { IInput } from "../form/Input";
import { useTypedSelector } from "../../hooks/useTypedSelector";
import { getAgentRoles, getVendorRoles } from "../../store/commonSlice";
import { ITicketRole } from "../../model/ITicketRole";

const addPostfixToRoles = (postfix: string, roles: (ITicketRole)[] = []) => roles.map((role) => ({
  ...role,
  name: `${role.name}${postfix}`
}))

const UserRolesSelectSearch: FC<IInput & {
  roles: TRole[],
  selectHandler?: TSelectHandler<IOrder>,
}> = ({
  roles,
  ...props
}) => {
    // -- If there are more then one group roles in the scope - add postfix
    const agentRoles = addPostfixToRoles(roles?.length > 1 ? ' (Agent)' : '', useTypedSelector(getAgentRoles()));
    const vendorRoles = addPostfixToRoles(roles?.length > 1 ? ' (Vendor)' : '', useTypedSelector(getVendorRoles()));

    // -- Set base scope
    const rolesScope = useMemo(() => [
      ...(roles.includes('ROLE_AGENT') && agentRoles?.length
        ? agentRoles
        : []
      ),
      ...(roles.includes('ROLE_VENDOR') && vendorRoles?.length
        ? vendorRoles
        : []
      ),
    ], [roles]);

    return (
      <Input
        options={rolesScope?.map(({ id, name }) => ({
          title: name,
          value: id
        })
        )}
        {...props}
        value={props?.value || rolesScope?.[0]?.id}
      />
    );
  }
/*
const UserRolesSelectSearch: FC<IInput & {
  roles: TRole[],
  selectHandler?: TSelectHandler<IOrder>,
}> = ({
  roles,
  ...props
}) => {
    const [searchState, setSearchState] = useState<string>();

    // -- If there are more then one group roles in the scope - add postfix
    const agentRoles = addPostfixToRoles(roles?.length > 1 ? ' (Agent)' : '', useTypedSelector(getAgentRoles()));
    const vendorRoles = addPostfixToRoles(roles?.length > 1 ? ' (Vendor)' : '', useTypedSelector(getVendorRoles()));

    // -- Set base scope
    const rolesScope = useMemo(() => [
      ...(roles.includes('ROLE_AGENT') && agentRoles?.length
        ? agentRoles
        : []
      ),
      ...(roles.includes('ROLE_VENDOR') && vendorRoles?.length
        ? vendorRoles
        : []
      ),
    ], [roles]);


    // -- Search inputed string in the common scope
    const foundRoles = useMemo(() => !searchState || !searchState?.trim()
      ? (rolesScope || [])
      : (rolesScope || []).filter(({ id }) =>
        id
        && searchState?.trim()
        && id.toLowerCase().includes(searchState.trim().toLowerCase()))
      , [rolesScope, searchState]);

    return (
      <SelectSearch
        searchState={searchState}
        setSearchState={setSearchState}
        searchResultList={foundRoles.map(({ id, name }) => ({ value: id, title: name }))}
        {...props}
      />
    );
  }
*/
export default UserRolesSelectSearch;
